import { render, staticRenderFns } from "./AddonAppCard.vue?vue&type=template&id=2e85318a&scoped=true"
import script from "./AddonAppCard.vue?vue&type=script&lang=js"
export * from "./AddonAppCard.vue?vue&type=script&lang=js"
import style0 from "./AddonAppCard.vue?vue&type=style&index=0&id=2e85318a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e85318a",
  null
  
)

export default component.exports